import React from "react";
import { process } from "../mock";
import { ArrowRight } from "lucide-react";

const Process = () => {
  return (
    <section id="process" className="py-24 bg-[#F5F7FB] dark:bg-[#08132C]">
      <div className="container-x">
        <div className="max-w-3xl reveal">
          <span className="tag-chip">Our Approach</span>
          <h2 className="section-title mt-4">How we deliver enterprise data engineering</h2>
          <p className="section-sub mt-5">
            A proven six-stage delivery model that goes from discovery to scale — designed for measurable outcomes at enterprise complexity.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {process.map((p, i) => (
            <div key={p.step} className="reveal group relative bg-white dark:bg-[#0B1B3B] border border-slate-200 dark:border-white/10 rounded-2xl p-7 hover-lift overflow-hidden">
              <div className="relative">
                <div className="flex items-center gap-3">
                  <span className="h-1 w-8 rounded-full bg-[#1E56E3]" />
                  <span className="text-xs font-semibold uppercase tracking-wider text-[#1E56E3]">Step {p.step}</span>
                </div>
                <h3 className="mt-3 text-xl font-bold text-[#0B1B3B] dark:text-white">{p.title}</h3>
                <p className="mt-3 text-[14px] text-slate-600 dark:text-slate-300 leading-relaxed">{p.desc}</p>
                {i < process.length - 1 && (
                  <div className="absolute -right-2 top-1/2 -translate-y-1/2 hidden lg:block opacity-0 group-hover:opacity-100 transition-opacity">
                    <ArrowRight className="text-[#1E56E3]" size={20} />
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
